module.exports = __webpack_public_path__ + "img/pingan_login_bg.410d3a91.jpg";